export const addService = "addService";
export const removeService = "removeService";
export const clearServices = "clearServices";

export const initializeBasket = "initializeBasket";
export const modifyBasket = "modifyBasket";
